import React from "react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

export default function StaticPage({ title, subtitle, children }) {
  return (
    <div>
      <PublicNav />
      <section className="max-w-5xl mx-auto px-6 py-20">
        <h1 className="text-4xl sm:text-5xl font-heading font-bold text-slate-900">{title}</h1>
        {subtitle && <p className="mt-4 text-lg text-slate-600 max-w-2xl">{subtitle}</p>}
        <div className="mt-10 prose prose-slate max-w-none">{children}</div>
      </section>
      <Footer />
    </div>
  );
}
